export const CHAT_NOT_FOUND_ERROR = 'Chat not found';
